
import Navbar from '../../components/feature/Navbar';
import Hero from './components/Hero';
import FeaturesBar from './components/CategoryNav';
import HowItWorks from './components/FeaturedArticles';
import TemplatesGallery from './components/LatestArticles';
import WhyChooseUs from './components/MissionSection';
import Testimonials from './components/Testimonials';
import CTASection from './components/Newsletter';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar transparent />
      <Hero />
      <FeaturesBar />
      <HowItWorks />
      <TemplatesGallery />
      <WhyChooseUs />
      <Testimonials />
      <CTASection />
      <Footer />
    </div>
  );
}
